angular.
module("dx.webapp.rubrics").
factory("dxRubricsRepository", function rubricsRepositoryService(
	$http,

	RepositoryConstructor,
	GradingMatrix,

	dxSession
) {
	"use strict";


	var itemConstructor = GradingMatrix;
	var draftType = "GradingMatrix";
	var urls = {
		load: "/gradingmatrix/",
		loadDefault: "/api/v1/gradingmatrix/list?archived=false",
		loadArchived: "/api/v1/gradingmatrix/list?archived=true",
		save: "/api/v1/gradingmatrix/save",
		loadDraft: "/draft/" + draftType + "/",
		saveDraft: "/draft/save/",
	};

	function removeShare(matrix) {
		var items = this.items;

		return $http.delete("/api/v1/rubrics/" + matrix.id + "/shares?userId=" + dxSession.getUser().id).then(function success() {
			var index = items.indexOf(matrix);
			if (index > -1) {
				items.splice(index, 1);
			}
			return true;
		}, function failed() {
			return false;
		});
	}

	function loadListResponseHandler(response) {
		var newResponse = {
			data: [],
		};

		// Set the name of the creator for shared matrices by matching user id.
		if (angular.isArray(response.data.gradingMatrices) && angular.isArray(response.data.users)) {
			for (var i = 0; i < response.data.gradingMatrices.length; i++) {
				var matrix = response.data.gradingMatrices[i];

				for (var j = 0; j < response.data.users.length; j++) {
					var user = response.data.users[j];

					if (matrix.userId === user.id) {
						matrix.createdBy = user.firstName + " " + user.lastName;
					}
				}

				newResponse.data.push(matrix);
			}
		}
		return this.successCallback(newResponse);
	}

	function loadDefault() {
		return $http({
			method: "GET",
			url: this.urls.loadDefault,
		}).then(loadListResponseHandler.bind(this), this.errorCallback);
	}

	function loadArchived() {
		return $http({
			method: "GET",
			url: this.urls.loadArchived,
		}).then(loadListResponseHandler.bind(this), this.errorCallback);
	}

	return new RepositoryConstructor({
		itemConstructor: itemConstructor,
		draftType: draftType,
		urls: urls,
		removeShare: removeShare,
		loadDefault: loadDefault,
		loadArchived: loadArchived,
	});
});
